import { CrumbContext } from "App2";
import { BreadcrumbItemType } from "antd/es/breadcrumb/Breadcrumb";
import { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getItemWithExpiration } from "utils/localStorageUtil";

export default function Board() {
  const ignore = useRef(false);
  const user = getItemWithExpiration("user");

  const navigate = useNavigate();

  const crumb = useContext(CrumbContext);

  useEffect(() => {
    if (ignore.current) return;

    let _crumbItems: BreadcrumbItemType[] = [
      {
        key: "a",
        title: "首页",
        href: "/console",
      },
      {
        key: "b",
        title: "数据看板",
        href: "/console/board",
      },
    ];
    crumb.setCrumbItems(
      (crumbItems: BreadcrumbItemType[]) => (crumbItems = _crumbItems)
    );

    return () => {
      ignore.current = !ignore.current;
    };
  }, []);

  return <>Board</>;
}
